<template>
  <div id="border">
    <p
      class="typeTIle"
      v-if="
        moduleList.filter((e) => {
          return !!e.open_status
        }).length
      "
    >
      已开通
    </p>
    <div class="box-body">
      <el-card
        class="box-card"
        shadow="hover"
        v-for="(module, i) in moduleList.filter((e) => {
          return !!e.open_status
        })"
        :key="i"
      >
        <div slot="header" class="clearfix" style="display: inline">
          <span class="leftImage" :style="{ backgroundColor: findtypeList(module, 'backColor') }">
            <svg aria-hidden="true" class="icon svg-icon iconStyle">
              <use :xlink:href="findtypeList(module, 'imgSrc')"></use>
            </svg>
            <!-- <img
              :src="findtypeList(module, 'imgSrc')"
              width="16px"
              height="16px"
              alt=""
            /> -->
          </span>
          <span class="pay_title">
            {{ typeListTrans(module.account_module) }}
          </span>
          <!-- pay_status-->
          <div v-if="!isShow" :class="['tagStatus', isEnough(module) ? 'tagStatusO' : isArrears(module) ? 'tagStatusR' : 'tagStatusG']">
            <span v-if="isEnough(module)"> 余额不足 </span>
            <span v-else-if="isArrears(module)"> 欠费 </span>
            <span v-else>正常</span>
          </div>
          <!-- <span
            class="pay_status"
            :class="module.open_status ? 'pay_status_yes' : 'pay_status_no'"
          >
            {{ openStatusTrans(module.open_status) }}
          </span> -->
          <el-switch
            v-model="module.open_status"
            style="float: right; padding: 3px 0"
            active-color="#13ce66"
            inactive-color="#ff4949"
            :active-value="1"
            :inactive-value="0"
            @change="changeState(module)"
            v-if="isShow"
          >
          </el-switch>
        </div>
        <div class="text item textItem">
          <el-row
            class="bottom_row"
            v-for="(item, index) in findtypeList(module, 'menuList')"
            :key="index"
            :style="{
              display: item.isShowBtn || item.isShowBtn == undefined ? 'flex' : 'none'
            }"
          >
            <!-- open_status-->
            <el-col :span="12" class="pay_content">
              {{ item.title }}
            </el-col>
            <el-col :span="12" style="text-align: right; text-overflow: ellipsis; overflow: hidden">
              <template v-if="item.custom">
                <!-- pay_status-->
                <template v-if="item.custom === 1">
                  <span class="redColor" v-if="isEnough(module)"> 余额不足 </span>
                  <span class="redColor" v-else-if="isArrears(module)"> 欠费 </span>
                  <span v-else>正常</span>
                </template>
                <!-- open_status-->
                <template v-if="item.custom === 2">
                  {{ parseInt(module[item.valueMax] ? module[item.valueMax] : 0) - parseInt(module[item.valueMin] ? module[item.valueMin] : 0) }}
                </template>
              </template>
              <template v-else>
                <template v-if="module[item.value] != null">
                  <el-tooltip effect="dark" :content="module[item.value].toString()" placement="top-start">
                    <el-link type="primary" :underline="false" v-if="item.value == 'online_user'" @click="handleButtonEvent(item.value)">{{
                      handleButtonName(module[item.value])
                    }}</el-link>
                    <span v-else>{{ handleButtonName(module[item.value]) }}</span>
                  </el-tooltip>
                </template>
              </template>
            </el-col>
          </el-row>
          <!--红色提醒-->
          <div class="bottom clearfix redAction">
            <template v-if="findtypeList(module, 'isShowRed')">
              <!--30天以内快要过期-->
              <div v-if="module.remainDays < 30">
                {{ `${module['expire_time']}到期(还有${module['remainDays']}天)` }}
              </div>
              <!--剩余用户数30以内-->
              <div v-if="module.total_user !== null && module['total_user'] - module['userCount'] < 30">
                {{ `剩余可增用户${module['total_user'] - module['userCount']}` }}
              </div>
              <!--剩余可用次数100以内-->
              <div v-if="module.total_times !== null && module['total_recharge'] - module['total_times'] < 100">
                {{ `剩余可用次数${module['total_recharge'] - module['total_times']}` }}
              </div>
            </template>
          </div>
        </div>

        <el-divider class="customDivider" v-if="handleStatus(module)"></el-divider>

        <!--判断是否开通服务-->
        <div class="clearfix bttonlist" v-if="handleStatus(module)">
          <span v-for="(items, indexs) in findtypeList(module, 'toolsList')" :key="indexs">
            <el-button
              v-if="checkTenant(items.isTenant, module)"
              size="mini"
              :class="items.name == '立即充值' ? 'primaryBtn' : 'blurBorderBtn'"
              :style="{ marginRight: indexs == findtypeList(module, 'toolsList').length - 1 ? 0 : '5px' }"
              @click="showFuns(items.funs, module)"
            >
              {{ items.name }}
            </el-button>
          </span>
        </div>
      </el-card>
    </div>
    <p
      class="typeTIle"
      v-if="
        moduleList.filter((e) => {
          return !e.open_status
        }).length
      "
    >
      未开通
    </p>
    <div class="box-body">
      <el-card
        class="box-card"
        shadow="hover"
        v-for="(module, i) in moduleList.filter((e) => {
          return !e.open_status
        })"
        :key="i"
      >
        <div slot="header" class="clearfix" style="display: inline">
          <span class="leftImage" :style="{ backgroundColor: findtypeList(module, 'backColor') }">
            <svg aria-hidden="true" class="icon svg-icon iconStyle">
              <use :xlink:href="findtypeList(module, 'imgSrc')"></use>
            </svg>
          </span>
          <span class="pay_title">
            {{ typeListTrans(module.account_module) }}
          </span>
          <!-- <span
            class="pay_status"
            :class="module.open_status ? 'pay_status_yes' : 'pay_status_no'"
          >
            {{ openStatusTrans(module.open_status) }}
          </span> -->
          <el-switch
            v-model="module.open_status"
            style="float: right; padding: 3px 0"
            active-color="#13ce66"
            inactive-color="#ff4949"
            :active-value="1"
            :inactive-value="0"
            @change="changeState(module)"
            v-if="isShow"
          >
          </el-switch>
        </div>
        <div class="text item textItem">
          <el-row
            class="bottom_row"
            v-for="(item, index) in findtypeList(module, 'menuList')"
            :key="index"
            :style="{
              display: item.isShowBtn || item.isShowBtn == undefined ? 'flex' : 'none'
            }"
          >
            <!-- open_status-->
            <el-col :span="12" class="pay_content">
              {{ item.title }}
            </el-col>
            <el-col :span="12" style="text-align: right; text-overflow: ellipsis; overflow: hidden">
              <template v-if="item.custom">
                <!-- pay_status-->
                <template v-if="item.custom === 1">
                  <span class="redColor" v-if="isEnough(module)"> 余额不足 </span>
                  <span class="redColor" v-else-if="isArrears(module)"> 欠费 </span>
                  <span v-else>正常</span>
                </template>
                <!-- open_status-->
                <template v-if="item.custom === 2">
                  {{ parseInt(module[item.valueMax] ? module[item.valueMax] : 0) - parseInt(module[item.valueMin] ? module[item.valueMin] : 0) }}
                </template>
              </template>
              <template v-else>
                <template v-if="module[item.value] != null">
                  <el-tooltip effect="dark" :content="module[item.value].toString()" placement="top-start">
                    <el-link type="primary" :underline="false" v-if="item.value == 'online_user'" @click="handleButtonEvent(item.value)">{{
                      handleButtonName(module[item.value])
                    }}</el-link>
                    <span v-else>{{ handleButtonName(module[item.value]) }}</span>
                  </el-tooltip>
                </template>
              </template>
            </el-col>
          </el-row>
          <!--红色提醒-->
          <div class="bottom clearfix redAction">
            <template v-if="findtypeList(module, 'isShowRed')">
              <!--30天以内快要过期-->
              <div v-if="module.remainDays < 30">
                {{ `${module['expire_time']}到期(还有${module['remainDays']}天)` }}
              </div>
              <!--剩余用户数30以内-->
              <div v-if="module.total_user !== null && module['total_user'] - module['userCount'] < 30">
                {{ `剩余可增用户${module['total_user'] - module['userCount']}` }}
              </div>
              <!--剩余可用次数100以内-->
              <div v-if="module.total_times !== null && module['total_recharge'] - module['total_times'] < 100">
                {{ `剩余可用次数${module['total_recharge'] - module['total_times']}` }}
              </div>
            </template>
          </div>
        </div>

        <el-divider class="customDivider" v-if="handleStatus(module)"></el-divider>

        <!--判断是否开通服务-->
        <div class="clearfix bttonlist" v-if="handleStatus(module)">
          <span v-for="(items, indexs) in findtypeList(module, 'toolsList')" :key="indexs">
            <el-button
              v-if="checkTenant(items.isTenant, module)"
              size="mini"
              :class="items.name == '立即充值' ? 'primaryBtn' : 'blurBorderBtn'"
              :style="{ marginRight: indexs == findtypeList(module, 'toolsList').length - 1 ? 0 : '5px', marginBottom: '5px' }"
              @click="showFuns(items.funs, module)"
            >
              {{ items.name }}
            </el-button>
          </span>
        </div>
      </el-card>
    </div>

    <!--充值-->
    <el-drawer
      class="sideDrawer"
      destroy-on-close
      :size="drawerSize"
      :close-on-click-modal="false"
      :title="recharge.title"
      :visible="showDetail"
      :before-close="beforeCloseDialog"
      append-to-body
      v-loading="loading"
    >
      <i class="iconfont icon-back-quanping iconFull" @click="drawerSize = '100%'" v-if="drawerSize == '70%'" />
      <i @click="drawerSize = '70%'" class="iconfont icon-back-tuichuquanping iconFull" v-else />
      <div slot="title" class="dialog-header-title">
        <span class="name">{{ recharge.title }}</span>
      </div>
      <div class="content" style="padding: 20px">
        <el-row style="height: 4rem">
          <el-col :span="12">
            <el-row>
              <el-col :span="6"> <span style="color: red" v-if="recharge.startTime == ''">*</span>开始时间： </el-col>
              <el-col :span="18">
                <el-date-picker v-model="recharge.startTime" align="right" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"> </el-date-picker>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row>
              <el-col :span="6"> <span style="color: red" v-if="recharge.endTime == ''">*</span>结束时间： </el-col>
              <el-col :span="18">
                <el-date-picker v-model="recharge.endTime" align="right" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"> </el-date-picker>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-row style="height: 4rem">
          <el-col :span="12">
            <el-row>
              <el-col :span="6"> <span style="color: red" v-if="recharge.amount == ''">*</span>充值金额(元)： </el-col>
              <el-col :span="18">
                <el-input-number v-model="recharge.amount" :controls="false" :precision="2" :min="0" :max="9999999999"> </el-input-number>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-row style="height: 4rem">
          <el-col>
            <el-row>
              <el-col :span="3">备注：</el-col>
              <el-col :span="19">
                <el-input v-model="recharge.remarks" placeholder=" " clearable maxlength="200" show-word-limit type="textarea"> </el-input>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-row style="height: 4rem; margin-top: 2rem">
          <el-col :span="12">
            <el-row>
              <el-col :span="6"> 编制人：</el-col>
              <el-col :span="8">
                <el-input v-model="recharge.currentUser" placeholder=" " disabled> </el-input>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row>
              <p style="text-align: right; line-height: 32px; padding-right: 10px; width: 212px">编制时间：</p>
              <p style="width: calc(100% - 232px)">
                <el-date-picker v-model="recharge.createTime" style="width: 100%" align="right" type="datetime" placeholder="选择日期" disabled>
                </el-date-picker>
              </p>
            </el-row>
          </el-col>
        </el-row>
      </div>
      <div class="demo-drawer__footer">
        <el-button size="small" @click="showDetail = false">取消</el-button>
        <el-button size="small" type="primary" @click="saveRecharge">确定</el-button>
      </div>
    </el-drawer>
    <el-drawer
      class="sideDrawer"
      destroy-on-close
      :size="drawerSize"
      :close-on-click-modal="false"
      :title="title"
      :visible="showTaxNo"
      :before-close="beforeCloseDialog1"
      append-to-body
      v-loading="loading"
      ><i class="iconfont icon-back-quanping iconFull" @click="drawerSize = '100%'" v-if="drawerSize == '70%'" />
      <i @click="drawerSize = '70%'" class="iconfont icon-back-tuichuquanping iconFull" v-else />
      <div slot="title" class="dialog-header-title">
        <span class="name">{{ title }}</span>
      </div>
      <div class="content" style="padding: 20px">
        <el-row style="height: 4rem">
          <el-col :span="12">
            <el-row>
              <el-col :span="2"> 税号</el-col>
              <el-col :span="20">
                <el-input v-model="tax.taxNo" placeholder=" " clearable></el-input>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>
      <div class="demo-drawer__footer">
        <el-button @click="showTaxNo = false">取消</el-button>
        <el-button size="small" type="primary" @click="saveTaxNo">确定</el-button>
      </div>
    </el-drawer>
    <el-drawer
      class="sideDrawer"
      destroy-on-close
      :size="drawerSize"
      :close-on-click-modal="false"
      :title="title"
      :visible="showBWTaxNo"
      :before-close="beforeCloseDialog6"
      append-to-body
      v-loading="loading"
    >
      <i class="iconfont icon-back-quanping iconFull" @click="drawerSize = '100%'" v-if="drawerSize == '70%'" />
      <i @click="drawerSize = '70%'" class="iconfont icon-back-tuichuquanping iconFull" v-else />
      <div slot="title" class="dialog-header-title">
        <span class="name">{{ title }}</span>
      </div>
      <div class="content" style="padding: 20px">
        <el-row style="height: 4rem">
          <el-col :span="12">
            <el-row>
              <el-col :span="2"> 税号</el-col>
              <el-col :span="20">
                <el-input v-model="tax.taxNo" placeholder=" " clearable></el-input>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>
      <div class="demo-drawer__footer">
        <el-button size="small" @click="showBWTaxNo = false">取消</el-button>
        <el-button size="small" type="primary" @click="saveBWTaxNo">确定</el-button>
      </div>
    </el-drawer>
    <el-drawer
      class="sideDrawer"
      destroy-on-close
      :size="drawerSize"
      :close-on-click-modal="false"
      :title="title"
      :visible="showNcType"
      :before-close="beforeCloseDialog2"
      append-to-body
      v-loading="loading"
      ><i class="iconfont icon-back-quanping iconFull" @click="drawerSize = '100%'" v-if="drawerSize == '70%'" />
      <i @click="drawerSize = '70%'" class="iconfont icon-back-tuichuquanping iconFull" v-else />
      <div slot="title" class="dialog-header-title">
        <span class="name">{{ title }}</span>
      </div>
      <div class="content" style="padding: 20px">
        <el-row style="height: 4rem; display: flex">
          <p style="text-align: right; line-height: 32px; padding-right: 10px; width: 212px">系统类型</p>
          <p style="width: calc(100% - 232px)">
            <el-select style="width: 100%" v-model="ncConfig.ncType" placeholder="请选择">
              <!-- <el-option label="K3" value="k3"></el-option> -->
              <el-option v-for="item in optionsList" :key="item.id" :value="item.id" :label="item.desc"></el-option>
            </el-select>
          </p>
        </el-row>
        <template v-if="ncConfig.ncType == 'k3'">
          <el-row style="height: 4rem; display: flex">
            <p style="text-align: right; line-height: 32px; padding-right: 10px; width: 212px">对接地址</p>
            <p style="width: calc(100% - 232px)">
              <el-input style="width: 100%" v-model="ncConfig.ncUrl" placeholder="" clearable></el-input>
            </p>
          </el-row>
        </template>
        <template v-else>
          <el-row style="height: 4rem; display: flex">
            <p style="text-align: right; line-height: 32px; padding-right: 10px; width: 212px">应用id</p>
            <p style="width: calc(100% - 232px)">
              <el-input style="width: 100%" v-model="ncConfig.ncFinanceClientId" placeholder="" clearable></el-input>
            </p>
          </el-row>
          <el-row style="height: 4rem; display: flex">
            <p style="text-align: right; line-height: 32px; padding-right: 10px; width: 212px">应用秘钥</p>
            <p style="width: calc(100% - 232px)">
              <el-input style="width: 100%" v-model="ncConfig.ncFinanceClientSecret" placeholder="" clearable></el-input>
            </p>
          </el-row>
        </template>
      </div>
      <div class="demo-drawer__footer">
        <el-button size="small" @click="showNcType = false">取消</el-button>
        <el-button size="small" type="primary" @click="saveNc">确定</el-button>
      </div>
    </el-drawer>
    <el-drawer
      class="sideDrawer"
      destroy-on-close
      :size="drawerSize"
      :close-on-click-modal="false"
      :title="title"
      :visible="showZfb"
      :before-close="beforeCloseZfbDialog"
      append-to-body
      v-loading="loading"
      ><i class="iconfont icon-back-quanping iconFull" @click="drawerSize = '100%'" v-if="drawerSize == '70%'" />
      <i @click="drawerSize = '70%'" class="iconfont icon-back-tuichuquanping iconFull" v-else />
      <div slot="title" class="dialog-header-title">
        <span class="name">{{ title }}</span>
      </div>
      <div class="content" style="padding: 20px">
        <el-row style="height: 4rem">
          <el-col :span="12">
            <el-row>
              <el-col :span="8">绑定支付宝账号</el-col>
              <el-col :span="14">
                <el-input v-model="zfb.zfbAccount" placeholder="" clearable></el-input>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row>
              <el-col :span="8">账户名称</el-col>
              <el-col :span="14">
                <el-input v-model="zfb.zfbName" placeholder="" clearable></el-input>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-row style="height: 4rem; display: flex">
          <p style="text-align: right; line-height: 32px; padding-right: 10px; width: 212px">备注</p>
          <p style="width: calc(100% - 232px)">
            <el-input style="width: 100%" v-model="zfb.fbRemarkes" placeholder="" clearable></el-input>
          </p>
        </el-row>
        <el-row style="height: 4rem">
          <el-col :span="24">
            1、您的企业支付宝<span style="color: #aa1111">未在</span>其他系统签约过 [支付宝批量转账接口]，请点击<span style="color: #aa1111"
              >[签约授权一体]</span
            >按钮进行签约和授权。<br />
            2、您的企业支付宝<span style="color: #aa1111">已经</span>在其他系统签约过 [支付宝批量转账接口]，请点击<span style="color: #aa1111">[授权]</span
            >按钮为易筑云平台进行授权。
          </el-col>
        </el-row>
      </div>
      <div class="demo-drawer__footer">
        <el-button size="small" @click="showZfb = false">取消</el-button>
        <el-button size="small" type="primary" @click="saveDataZfbSign">签约授权一体</el-button>
        <el-button size="small" type="primary" @click="saveDataZfbOauth">授权</el-button>
      </div>
    </el-drawer>
    <!--招行CBS-->
    <el-drawer
      class="sideDrawer"
      destroy-on-close
      :size="drawerSize"
      :close-on-click-modal="false"
      :title="title"
      :visible="showCbsType"
      :before-close="beforeCloseCbsDialog"
      append-to-body
      v-loading="loading"
      ><i class="iconfont icon-back-quanping iconFull" @click="drawerSize = '100%'" v-if="drawerSize == '70%'" />
      <i @click="drawerSize = '70%'" class="iconfont icon-back-tuichuquanping iconFull" v-else />
      <div slot="title" class="dialog-header-title">
        <span class="name">{{ title }}</span>
      </div>
      <div class="content" style="padding: 20px">
        <el-row style="height: 4rem; display: flex">
          <p style="text-align: right; line-height: 32px; padding-right: 10px; width: 212px">系统类型</p>
          <p style="width: calc(100% - 232px)">
            <el-select v-model="cbsConfig.finance_acct_name" style="width: 100%">
              <el-option v-for="(m, i) in finance_acct_nameList" :key="i" :value="m.value" :label="m.label"></el-option>
            </el-select>
          </p>
        </el-row>
        <el-row style="height: 4rem; display: flex">
          <p style="text-align: right; line-height: 32px; padding-right: 10px; width: 212px">企业号</p>
          <p style="width: calc(100% - 232px)">
            <el-input style="width: 100%" v-model="cbsConfig.cbsOrgNo" placeholder="" clearable></el-input>
          </p>
        </el-row>
        <el-row style="height: 4rem; display: flex">
          <p style="text-align: right; line-height: 32px; padding-right: 10px; width: 212px">对接地址</p>
          <p style="width: calc(100% - 232px)">
            <el-input v-model="cbsConfig.cbsUrl" style="width: 100%" placeholder="" clearable></el-input>
          </p>
        </el-row>
      </div>
      <div class="demo-drawer__footer">
        <el-button size="small" @click="showCbsType = false">取消</el-button>
        <el-button size="small" type="primary" @click="saveCbs">确定</el-button>
      </div>
    </el-drawer>
    <!-- 初始化配置 -->
    <el-drawer
      class="sideDrawer"
      destroy-on-close
      :size="drawerSize"
      :close-on-click-modal="false"
      :title="title"
      :visible="showInitsType"
      :before-close="beforeCloseInitDialog"
      append-to-body
      v-loading="loading"
    >
      <i class="iconfont icon-back-quanping iconFull" @click="drawerSize = '100%'" v-if="drawerSize == '70%'" />
      <i @click="drawerSize = '70%'" class="iconfont icon-back-tuichuquanping iconFull" v-else />
      <div slot="title" class="dialog-header-title">
        <span class="name">{{ title }}</span>
      </div>
      <div class="content" style="padding: 20px">
        <el-row style="height: 4rem; display: flex">
          <p style="text-align: right; line-height: 32px; padding-right: 10px; width: 212px">开通时间</p>
          <p style="width: calc(100% - 232px)">
            <el-input style="width: 100%" v-model="InitConfig.initial_open_time" disabled></el-input>
          </p>
        </el-row>
        <el-row style="height: 4rem; display: flex">
          <p style="text-align: right; line-height: 32px; padding-right: 10px; width: 212px">使用天数</p>
          <p style="width: calc(100% - 232px)">
            <el-input v-model="InitConfig.totalUseDays" style="width: 100%" placeholder="" disabled></el-input>
          </p>
        </el-row>
        <el-row style="height: 4rem; display: flex">
          <p style="text-align: right; line-height: 32px; padding-right: 10px; width: 212px">系统类型</p>
          <p style="width: calc(100% - 232px)">
            <el-input style="width: 100%" v-model="InitConfig.tax_no_name" disabled></el-input>
          </p>
        </el-row>
        <el-row style="height: 4rem; display: flex">
          <p style="text-align: right; line-height: 32px; padding-right: 10px; width: 212px">推送用户名</p>
          <p style="width: calc(100% - 232px)">
            <el-input v-model="InitConfig.finance_user_name" style="width: 100%" placeholder="请输入推送用户名"></el-input>
          </p>
        </el-row>
        <el-row style="height: 4rem; display: flex">
          <p style="text-align: right; line-height: 32px; padding-right: 10px; width: 212px">推送用户密码</p>
          <p style="width: calc(100% - 232px)">
            <el-input v-model="InitConfig.finance_user_password" style="width: 100%" placeholder="请输入推送用户密码" type="password"></el-input>
          </p>
        </el-row>
        <el-row style="height: 4rem; display: flex">
          <p style="text-align: right; line-height: 32px; padding-right: 10px; width: 212px">企业名称</p>
          <p style="width: calc(100% - 232px)">
            <el-input v-model="InitConfig.finance_orgname" style="width: 100%" placeholder="" @click.native="ShowFinaceOraname"></el-input>
          </p>
        </el-row>
        <el-row style="height: 4rem; display: flex">
          <p style="text-align: right; line-height: 32px; padding-right: 10px; width: 212px">实例编码</p>
          <p style="width: calc(100% - 232px)">
            <el-input style="width: 100%" v-model="InitConfig.finance_pid" placeholder="" disabled></el-input>
          </p>
        </el-row>

        <el-row style="height: 4rem; display: flex">
          <p style="text-align: right; line-height: 32px; padding-right: 10px; width: 212px">账套名称</p>
          <p style="width: calc(100% - 232px)">
            <el-input v-model="InitConfig.finance_acct_name" style="width: 100%" placeholder="" @click.native="ShowAcctChangeName"></el-input>
          </p>
        </el-row>
        <el-row style="height: 4rem; display: flex">
          <p style="text-align: right; line-height: 32px; padding-right: 10px; width: 212px">账套号</p>
          <p style="width: calc(100% - 232px)">
            <el-input style="width: 100%" v-model="InitConfig.finance_acct_number" placeholder="" disabled></el-input>
          </p>
        </el-row>
        <el-row style="height: 4rem; display: flex">
          <p style="text-align: right; line-height: 32px; padding-right: 10px; width: 212px">应用服务编码</p>
          <p style="width: calc(100% - 232px)">
            <el-input v-model="InitConfig.finance_icrmid" style="width: 100%" placeholder="" disabled></el-input>
          </p>
        </el-row>
      </div>
      <div class="demo-drawer__footer">
        <el-button size="small" @click="showInitsType = false">取消</el-button>
        <el-button size="small" type="primary" @click="saveSubType">确定</el-button>
      </div>
    </el-drawer>
    <!-- cbs初始化配置 -->
    <el-drawer
      class="sideDrawer"
      destroy-on-close
      :size="drawerSize"
      :close-on-click-modal="false"
      :title="title"
      :visible="showInitsTypeCbs"
      :before-close="beforeCloseInitDialog"
      append-to-body
      v-loading="loading"
    >
      <i class="iconfont icon-back-quanping iconFull" @click="drawerSize = '100%'" v-if="drawerSize == '70%'" />
      <i @click="drawerSize = '70%'" class="iconfont icon-back-tuichuquanping iconFull" v-else />
      <div slot="title" class="dialog-header-title">
        <span class="name">{{ title }}</span>
      </div>
      <div class="content" style="padding: 20px">
        <el-row style="height: 4rem; display: flex">
          <p style="text-align: right; line-height: 32px; padding-right: 10px; width: 212px">系统类型</p>
          <p style="width: calc(100% - 232px)">
            <el-select v-model="InitConfigCbs.finance_acct_name" style="width: 100%" disabled>
              <el-option v-for="(m, i) in finance_acct_nameList" :key="i" :value="m.value" :label="m.label"></el-option>
            </el-select>
          </p>
        </el-row>
        <el-row style="height: 4rem; display: flex">
          <p style="text-align: right; line-height: 32px; padding-right: 10px; width: 212px">cbs应用id</p>
          <p style="width: calc(100% - 232px)">
            <el-input v-model="InitConfigCbs.finance_client_id" style="width: 100%" placeholder="请输入cbs应用id"></el-input>
          </p>
        </el-row>
        <el-row style="height: 4rem; display: flex">
          <p style="text-align: right; line-height: 32px; padding-right: 10px; width: 212px">cbs应用密钥</p>
          <p style="width: calc(100% - 232px)">
            <el-input style="width: 100%" placeholder="请输入cbs应用密钥" v-model="InitConfigCbs.finance_client_secret"></el-input>
          </p>
        </el-row>
        <el-row style="height: 4rem; display: flex">
          <p style="text-align: right; line-height: 32px; padding-right: 10px; width: 212px">cbs企业公钥</p>
          <p style="width: calc(100% - 232px)">
            <el-input v-model="InitConfigCbs.finance_pid" style="width: 100%" placeholder="请输入cbs企业公钥"></el-input>
          </p>
        </el-row>
        <el-row style="height: 4rem; display: flex">
          <p style="text-align: right; line-height: 32px; padding-right: 10px; width: 212px">cbs企业私钥</p>
          <p style="width: calc(100% - 232px)">
            <el-input v-model="InitConfigCbs.finance_acct_number" style="width: 100%" placeholder="请输入cbs企业私钥"></el-input>
          </p>
        </el-row>
        <el-row style="height: 4rem; display: flex">
          <p style="text-align: right; line-height: 32px; padding-right: 10px; width: 212px">cbs平台公钥</p>
          <p style="width: calc(100% - 232px)">
            <el-input v-model="InitConfigCbs.finance_icrmid" style="width: 100%" placeholder="请输入cbs平台公钥"></el-input>
          </p>
        </el-row>
        <el-row style="height: 4rem; display: flex">
          <p style="text-align: right; line-height: 32px; padding-right: 10px; width: 212px">对接地址</p>
          <p style="width: calc(100% - 232px)">
            <el-input v-model="InitConfigCbs.url" style="width: 100%" placeholder="请输入对接地址"></el-input>
          </p>
        </el-row>
      </div>
      <div class="demo-drawer__footer">
        <el-button size="small" @click="showInitsTypeCbs = false">取消</el-button>
        <el-button size="small" type="primary" @click="saveSubTypeCbs">确定</el-button>
      </div>
    </el-drawer>
    <!-- 企业选择器 -->
    <el-drawer
      class="sideDrawer"
      destroy-on-close
      :size="drawerSize"
      :close-on-click-modal="false"
      :title="title"
      :visible="showFinceName"
      :before-close="beforeCloseFinceDialog"
      append-to-body
      v-loading="loading"
    >
      <i class="iconfont icon-back-quanping iconFull" @click="drawerSize = '100%'" v-if="drawerSize == '70%'" />
      <i @click="drawerSize = '70%'" class="iconfont icon-back-tuichuquanping iconFull" v-else />
      <div slot="title" class="dialog-header-title">
        <span class="name">{{ title }}</span>
      </div>

      <el-table :data="tableData" border style="width: 100%; padding: 20px" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column prop="orgname" label="企业名称"> </el-table-column>
        <el-table-column prop="prodinstname" label="产品实例名称"> </el-table-column>
        <el-table-column prop="productname" label="产品名称"> </el-table-column>
        <el-table-column prop="productshortname" label="产品简称"> </el-table-column>
      </el-table>
      <div class="demo-drawer__footer" style="margin-top: 10px">
        <el-button size="small" @click="showFinceName = false">取消</el-button>
        <el-button size="small" type="primary" @click="saveFinance">确定</el-button>
      </div>
    </el-drawer>
    <!-- 账套选择器 -->
    <el-drawer
      class="sideDrawer"
      destroy-on-close
      :size="drawerSize"
      :close-on-click-modal="false"
      :title="title"
      :visible="showAcctName"
      :before-close="beforeCloseAcctDialog"
      append-to-body
      v-loading="loading"
      ><i class="iconfont icon-back-quanping iconFull" @click="drawerSize = '100%'" v-if="drawerSize == '70%'" />
      <i @click="drawerSize = '70%'" class="iconfont icon-back-tuichuquanping iconFull" v-else />
      <div slot="title" class="dialog-header-title">
        <span class="name">{{ title }}</span>
      </div>

      <el-table :data="AcctTable" border style="width: 100%; padding: 20px" @selection-change="handleAcctChange">
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column prop="acctname" label="账套名称"> </el-table-column>
        <el-table-column prop="acctnumber" label="账套号"> </el-table-column>
        <el-table-column prop="appname" label="应用名称"> </el-table-column>
      </el-table>
      <div class="demo-drawer__footer">
        <el-button size="small" @click="showAcctName = false">取消</el-button>
        <el-button size="small" type="primary" @click="saveAcct">确定</el-button>
      </div>
    </el-drawer>
    <el-drawer
      class="sideDrawer"
      destroy-on-close
      :size="drawerSize"
      title="充值历史"
      :visible.sync="drawer"
      direction="rtl"
      :before-close="handleClose"
      append-to-body
    >
      <i class="iconfont icon-back-quanping iconFull" @click="drawerSize = '100%'" v-if="drawerSize == '70%'" />
      <i @click="drawerSize = '70%'" class="iconfont icon-back-tuichuquanping iconFull" v-else />
      <div class="drawer_content" style="padding: 20px">
        <div class="noData_tips" v-if="!isHaving">暂无记录</div>
        <div v-for="item in chargeData" :key="item" v-else>
          <charge-record :chargeData="item"></charge-record>
        </div>
      </div>
    </el-drawer>
    <!-- 企查查的提醒 -->
    <remind-dialog-q-c-c :show="showRemindQCC" :data="reminderData" @closeReminderDialog="closeRemider"></remind-dialog-q-c-c>

    <!-- 其他提醒 -->
    <remind-dialog-common :show="showRemindOther" :data="reminderData" @closeReminderDialog="closeRemider"></remind-dialog-common>
    <!-- 维护 -->
    <maintain-bill
      :show="showMaintainDialog"
      :data="reminderData"
      :customer="{
        id: tenantId,
        name: tenantName
      }"
      @closeMaintainDialog="closeMaintain"
    ></maintain-bill>
    <!-- 账单记录 -->
    <billRecordDialog :tenantId="tenantId" :show="showbillRecord" :tempValue="reminderData" @closeBillingRecord="closeBillingRecord"></billRecordDialog>
    <!-- 关联用户 -->
    <relateUserDialog :tenantId="tenantId" :show="showRelateUser" :tempValue="reminderData" @closeRelateUser="closeRelateUser"></relateUserDialog>
    <!-- 添加订单 -->
    <insert-order :tenantId="tenantId" :tenantName="tenantName" :show="showInsertOrder" :tempValue="reminderData" @closeInsert="closeInsert"></insert-order>

    <!-- 用户选择器 -->
    <eip-user-dialog ref="eipUserDialog" @onConfirm="xzSyncUserDialogConfirm" :single="false" :userType="1" append-to-body />
    <!-- 新筑时代信息维护 -->
    <el-drawer
      class="sideDrawer"
      destroy-on-close
      :size="drawerSize"
      :close-on-click-modal="false"
      :title="title"
      :visible="showXzConfig"
      :before-close="beforeCloseXzSyncUserDialog"
      append-to-body
      v-loading="loading"
    >
      <div slot="title" class="dialog-header-title">
        <span class="name">{{ title }}</span>
      </div>
      <div class="content">
        <el-form ref="xzConfigForm" label-width="150px" :model="xzConfig" :rules="xzConfigRules" validate-on-rule-change="false">
          <el-form-item label="企业名称:" prop="company_name">
            <el-input v-model="xzConfig.company_name" placeholder="请输入企业名称"></el-input>
          </el-form-item>
          <el-form-item label="社会统一信用码:" prop="credit_code">
            <el-input v-model="xzConfig.credit_code" placeholder="请输入社会统一信用码"></el-input>
          </el-form-item>
          <el-form-item label="联系人姓名:" prop="contact_name">
            <el-input v-model="xzConfig.contact_name" placeholder="请输入联系人姓名"></el-input>
          </el-form-item>
          <el-form-item label="联系人手机号:" prop="contact_phone">
            <el-input v-model="xzConfig.contact_phone" placeholder="请输入联系人手机号"></el-input>
          </el-form-item>
          <el-row style="height: 4rem">
            <el-col :span="18">
              <el-form-item label="短信验证码:" prop="verification_code">
                <el-input v-model="xzConfig.verification_code" placeholder="请输入短信验证码"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6" style="text-align: right">
              <el-button type="primary" v-if="reSendName == 60" @click="sendSmsCode">发送验证码</el-button>
              <el-button type="info" disabled v-else color="#C4C4C6">{{ reSendName }}s后重新获取</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="demo-drawer__footer">
        <el-button size="small" @click="showXzConfig = false">取消</el-button>
        <el-button size="small" type="primary" @click="xzConfigConfirm">确定</el-button>
      </div>
    </el-drawer>
    <!-- 钉钉考勤接口 -->
    <el-drawer
      class="sideDrawer"
      destroy-on-close
      :size="drawerSize"
      :close-on-click-modal="false"
      :title="title"
      :visible="showDDConfig"
      :before-close="beforeCloseDialogDD"
      append-to-body
      v-loading="loading"
    >
      <div slot="title" class="dialog-header-title">
        <span class="name">{{ title }}</span>
      </div>
      <div class="content" style="padding: 20px">
        <el-row style="height: 4rem; display: flex">
          <p style="text-align: right; line-height: 32px; padding-right: 10px; width: 212px">CorpID:</p>
          <p style="width: calc(100% - 232px)">
            <el-input style="width: 100%" v-model="ddValue.corp_id" @blur="corpIDChange" placeholder=" " clearable></el-input>
          </p>
        </el-row>
        <el-row style="height: 4rem; display: flex">
          <p style="text-align: right; line-height: 32px; padding-right: 10px; width: 212px">AppKey:</p>
          <p style="width: calc(100% - 232px)">
            <el-input style="width: 100%" v-model="ddValue.app_key" @blur="corpIDChange" placeholder=" " clearable></el-input>
          </p>
        </el-row>
        <el-row style="height: 4rem; display: flex">
          <p style="text-align: right; line-height: 32px; padding-right: 10px; width: 212px">AppSecret:</p>
          <p style="width: calc(100% - 232px)">
            <el-input style="width: 100%" v-model="ddValue.app_secret" @blur="corpIDChange" placeholder=" " clearable></el-input>
          </p>
        </el-row>
        <el-row style="height: 4rem; display: flex">
          <p style="text-align: right; line-height: 32px; padding-right: 10px; width: 212px">EventToken:</p>
          <p style="width: calc(100% - 232px)">
            <el-input style="width: 100%" v-model="ddValue.event_token" placeholder=" " clearable></el-input>
          </p>
        </el-row>
        <el-row style="height: 4rem; display: flex">
          <p style="text-align: right; line-height: 32px; padding-right: 10px; width: 212px">EventAesKey:</p>
          <p style="width: calc(100% - 232px)">
            <el-input v-model="ddValue.event_aes_key" style="width: 100%" placeholder=" " clearable></el-input>
          </p>
        </el-row>
        <el-row style="height: 4rem; display: flex">
          <p style="text-align: right; line-height: 32px; padding-right: 10px; width: 212px">Ticket:</p>
          <p style="width: calc(100% - 232px)">
            <el-input style="width: 100%" v-model="ddValue.ticket" placeholder=" " clearable></el-input>
          </p>
        </el-row>
        <el-row style="height: 4rem; display: flex">
          <p style="text-align: right; line-height: 32px; padding-right: 10px; width: 212px">劳务班组架构:</p>
          <p style="width: calc(100% - 232px)">
            <el-select v-model="ddValue.labor_team_dept_id" style="width: 100%">
              <el-option v-for="(m, i) in ddConfigLwClass" :key="i" :value="m.id" :label="m.name"></el-option>
            </el-select>
          </p>
        </el-row>
        <el-row style="height: 4rem; display: flex">
          <p style="text-align: right; line-height: 32px; padding-right: 10px; width: 212px">考勤月报固化时间:</p>
          <p style="width: calc(100% - 232px)">
            每月
            <el-input-number v-model="ddValue.fixed_date" clearable min="1" max="30"></el-input-number>
            号
          </p>
        </el-row>
        <el-row style="height: 4rem; display: flex">
          <p style="text-align: right; line-height: 32px; padding-right: 10px; width: 212px">工人进场超龄需要上传体检报告:</p>
          <p style="width: calc(100% - 232px)">
            超
            <el-input-number v-model="ddValue.worker_overage" clearable min="0" max="200"></el-input-number>
            岁
          </p>
        </el-row>
      </div>
      <div class="demo-drawer__footer">
        <el-button size="small" @click="showDDConfig = false">取消</el-button>
        <el-button size="small" type="primary" @click="saveDDMaintain">确定</el-button>
      </div>
    </el-drawer>
    <!-- 美团参数配置弹框 -->
    <el-drawer
      class="sideDrawer"
      destroy-on-close
      :size="drawerSize"
      :close-on-click-modal="false"
      :title="title"
      :visible="showMTConfig"
      :before-close="beforeCloseDialogMT"
      append-to-body
      v-loading="loading"
    >
      <div slot="title" class="dialog-header-title">
        <span class="name">{{ title }}</span>
      </div>
      <div class="content" style="padding: 20px">
        <el-form ref="mtConfigForm" label-width="150px" :model="ddValue" :rules="mtConfigRules" validate-on-rule-change="false">
          <el-form-item label="entId:" prop="corp_id">
            <el-input v-model="ddValue.corp_id" @blur="corpIDChange" placeholder="entId"></el-input>
          </el-form-item>
          <el-form-item label="accessKey:" prop="event_token">
            <el-input v-model="ddValue.event_token" @blur="corpIDChange" placeholder="accessKey"></el-input>
          </el-form-item>
          <el-form-item label="secretKey:" prop="app_secret">
            <el-input v-model="ddValue.app_secret" @blur="corpIDChange" placeholder=" " clearable></el-input>
          </el-form-item>
          <el-form-item label="Ticket:" prop="ticket">
            <el-input v-model="ddValue.ticket" placeholder=" " clearable></el-input>
          </el-form-item>
          <el-form-item label="app_id:" prop="app_id">
            <el-input v-model="ddValue.app_id" placeholder=" " clearable></el-input>
          </el-form-item>
          <el-form-item label="app_private_key:" prop="app_private_key">
            <el-input v-model="ddValue.app_private_key" placeholder=" " clearable></el-input>
          </el-form-item>
          <el-form-item label="默认部门id:" prop="labor_team_dept_id">
            <el-input v-model="ddValue.labor_team_dept_id" placeholder=" " clearable type="number" maxlength="10"></el-input>
          </el-form-item>
          <el-form-item label="美团行程管控模式:" prop="control_mode">
            <el-radio-group v-model="ddValue.control_mode">
              <el-radio :label="1">申请单维度管控</el-radio>
              <el-radio :label="2">行程维度管控</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
      <div class="demo-drawer__footer">
        <el-button size="small" @click="showMTConfig = false">取消</el-button>
        <el-button size="small" type="primary" @click="saveMTMaintain">确定</el-button>
      </div>
    </el-drawer>
    <!-- 默认签署人 -->
    <el-drawer
      class="sideDrawer"
      destroy-on-close
      :size="drawerSize"
      :close-on-click-modal="false"
      :title="title"
      :visible="showQSRConfigVisible"
      :before-close="beforeCloseDialogQSR"
      append-to-body
      v-loading="loading"
    >
      <div slot="title" class="dialog-header-title">
        <span class="name">{{ title }}</span>
      </div>
      <div class="content" style="padding: 20px">
        <el-form ref="QSRConfigForm" label-width="150px" :model="ddValue" :rules="QSRConfigRules" :validate-on-rule-change="false">
          <el-form-item label="签署人:" prop="app_key">
            <el-input v-model="ddValue.app_key" placeholder="签署人"></el-input>
          </el-form-item>
          <el-form-item label="身份证:" prop="app_secret">
            <el-input v-model="ddValue.app_secret" placeholder="身份证"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="demo-drawer__footer">
        <el-button size="small" @click="showQSRConfigVisible = false">取消</el-button>
        <el-button size="small" type="primary" @click="saveQSRMaintain">确定</el-button>
      </div>
    </el-drawer>
    <!-- 天眼查配置 -->
    <el-drawer
      class="sideDrawer"
      destroy-on-close
      :size="drawerSize"
      :close-on-click-modal="false"
      :title="title"
      :visible="showTYCConfig"
      :before-close="beforeCloseDialogTYC"
      append-to-body
      v-loading="loading"
    >
      <div slot="title" class="dialog-header-title">
        <span class="name">{{ title }}</span>
      </div>
      <div class="content" style="padding: 20px">
        <el-form ref="tycConfigForm" label-width="150px" :model="tycValue" :rules="tycConfigRules" validate-on-rule-change="false">
          <el-form-item label="token/地址:" prop="tax_no">
            <el-input v-model="tycValue.tax_no" placeholder="token/地址"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="demo-drawer__footer">
        <el-button size="small" @click="showTYCConfig = false">取消</el-button>
        <el-button size="small" type="primary" @click="saveTYCMaintain">确定</el-button>
      </div>
    </el-drawer>
    <!-- 在线用户列表 -->
    <onlineUserRecordDialog :tenantId="tenantId" :show="showOnlineUserDialog" @closeOnlineUserRecord="closeOnlineUserRecord"></onlineUserRecordDialog>

    <!-- 用车规则维护列表 -->
    <ycgzListDialog v-if="ycgzList" :tenantId="tenantId" :show="ycgzList" :tempValue="reminderData" @closeYcgzList="closeYcgzList"></ycgzListDialog>
  </div>
</template>

<script>
import uc from '@/api/uc'

const chargeRecord = () => import('@/components/tenant/chargeRecord.vue')
import RemindDialogCommon from './remindDialogCommon.vue'
import RemindDialogQCC from './remindDialogQCC.vue'
import req from '@/request'
import { typeList, handleType } from './constants'
import MaintainBill from '../maintainCenter/maintainBill.vue'
import billRecordDialog from './billRecordDialog.vue'
import ycgzListDialog from './ycgzListDialog.vue'
import relateUserDialog from './relateUserDialog.vue'
import EipUserDialog from '@/components/dialog/EipUserDialog.vue'
import onlineUserRecordDialog from './onlineUserRecordDialog.vue'
import insertOrder from './insertOrder.vue'
import flow from '@/api/flow.js'
import portal from '@/api/portal.js'
import { mapState } from 'vuex'
import utils from '@/utils.js'
export default {
  components: {
    chargeRecord,
    RemindDialogCommon,
    RemindDialogQCC,
    billRecordDialog,
    ycgzListDialog,
    relateUserDialog,
    insertOrder,
    MaintainBill,
    EipUserDialog,
    onlineUserRecordDialog
  },
  props: {
    tenantIdProps: {
      type: String,
      default: () => ''
    },
    tenantNameProps: {
      type: String,
      default: () => ''
    }
  },
  data() {
    return {
      finance_acct_nameList: [],
      drawerSize: '70%',
      typeList,
      showTYCConfig: false,
      showInitsType: false,
      showInitsTypeCbs: false,
      showAcctName: false,
      showFinceName: false,
      ycgzList: false,
      tableData: [],
      AcctTable: [],
      title: '',
      isShow: false,
      moduleList: [{}],
      moduleTitle: '',
      recharge: {
        accountModule: '',
        title: '',
        startTime: '',
        endTime: '',
        amount: '',
        remarks: '',
        currentUser: '',
        createTime: ''
      },
      ddValue: {
        app_key: '',
        app_secret: '',
        corp_id: '',
        fixed_date: 0,
        labor_team_dept: '',
        ticket: '',
        event_token: '',
        event_aes_key: '',
        refId: '',
        worker_overage: 0,
        control_mode: '1',
        app_id: '',
        app_private_key: '',
        labor_team_dept_id: ''
      },
      mtValue: {
        entId: '',
        accessKey: '',
        secretKey: ''
      },
      ddConfigLwClass: [],
      tax: {
        taxNo: ''
      },
      InitConfig: {},
      InitConfigCbs: {},
      ncConfig: {
        ncType: '',
        ncUrl: '',
        ncFinanceClientId: '',
        ncFinanceClientSecret: ''
      },
      zfb: {
        zfbAccount: '',
        zfbName: '',
        zfbRemarkes: ''
      },
      cbsConfig: {
        cbsOrgNo: '',
        finance_acct_name: '',
        cbsUrl: ''
      },
      mtConfig: {
        entId: '',
        accessKey: '',
        secretKey: ''
      },
      chargeData: [],
      showDetail: false,
      showTaxNo: false,
      showBWTaxNo: false,
      showNcType: false,
      showZfb: false,
      showMtType: false,
      showCbsType: false,
      drawer: false,
      isHaving: false,
      showRemindQCC: false,
      showRemindOther: false,
      loading: false,
      maintainData: {},
      showMaintainDialog: false,
      showbillRecord: false,
      showDDConfig: false,
      showMTConfig: false,
      showQSRConfigVisible: false,
      showRelateUser: false,
      showInsertOrder: false,
      reminderData: {},
      tenantId: '',
      tenantName: '',
      optionsList: [],
      FinanceDate: {},
      AcctDate: {},
      showXzConfig: false,
      reSendName: 60,
      xzConfig: {
        company_name: '',
        credit_code: '',
        contact_name: '',
        contact_phone: '',
        verification_code: ''
      },
      xzConfigRules: {
        company_name: [{ required: true, message: '请输入企业名称', trigger: 'blur' }],
        credit_code: [{ required: true, message: '请输入社会统一信用码', trigger: 'blur' }],
        contact_name: [{ required: true, message: '请输入联系人姓名', trigger: 'blur' }],
        contact_phone: [{ required: true, message: '请输入联系人手机号码', trigger: 'blur' }],
        verification_code: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
      },
      mtConfigRules: {
        corp_id: [{ required: true, message: '请输入entId', trigger: 'blur' }],
        event_token: [{ required: true, message: '请输入accessKey', trigger: 'blur' }],
        app_secret: [{ required: true, message: '请输入secretKey', trigger: 'blur' }]
      },
      QSRConfigRules: {
        app_key: [{ required: true, message: '请输入签署人', trigger: 'blur' }],
        app_secret: [{ required: true, message: '请输入身份证', trigger: 'blur' }]
      },
      tycConfigRules: {
        tax_no: [{ required: true, message: '请输入token/地址', trigger: 'blur' }]
      },
      tycValue: {
        tax_no: '',
        id: ''
      },
      onlineUserCount: 0,
      showOnlineUserDialog: false
    }
  },
  computed: {
    ...mapState({
      allEnumerate: (state) => state.user.allEnumerate
    }),
    handleStatus() {
      return function (module) {
        if (module.open_status === 1 || module.open_status === 2 || (module.open_status === 0 && module.account_module === 11)) {
          return true
        } else {
          return false
        }
      }
    },
    handleButtonName() {
      return function (name) {
        if (name && name == 'kis_ultimate') {
          return '金蝶云旗舰版'
        } else {
          return name
        }
      }
    }
  },
  mounted() {
    let currentUser = this.$store.state.login.currentUser
    if (currentUser) {
      this.isShow = currentUser.tenantId === '-1'
    }
    // 判断props是否存在
    if (this.tenantIdProps === '') {
      if (this.$route.query.id) {
        this.tenantId = this.$route.query.id
        this.tenantName = this.$route.query.name
      } else {
        this.tenantId = currentUser.tenantId == '-1' ? '' : currentUser.tenantId
        this.tenantName = sessionStorage.getItem('tenantName')
      }
    } else {
      this.tenantId = this.tenantIdProps
      this.tenantName = this.tenantNameProps
    }
    this.getOnlineUser()
    this.getAccountMangement()
  },
  methods: {
    beforeCloseDialogTYC() {
      this.showTYCConfig = false
    },
    findtypeList(module, field) {
      let temp = this.typeList.find((itemsMenu) => module.account_module == itemsMenu.code)
      if (temp) {
        return temp[field]
      } else {
        return ''
      }
    },
    // 是否余额不足
    isEnough(module) {
      let enDays = module.remainDays < 30 && module.remainDays > 0
      let enUser = false
      if (module.account_module !== 1) {
        enUser = module.total_user !== null && module['total_user'] - module['userCount'] < 30 && module['total_user'] - module['userCount'] > 0
      }
      let enTimes =
        module.total_times !== null && module['total_recharge'] - module['total_times'] < 100 && module['total_recharge'] - module['total_times'] > 0
      return enDays || enUser || enTimes
    },
    // 是否欠费
    isArrears(module) {
      let enDays = module.remainDays < 1
      let enUser = false
      if (module.account_module !== 1) {
        enUser = module.total_user !== null && module['total_user'] - module['userCount'] < 1
      }
      let enTimes = module.total_times !== null && module['total_recharge'] - module['total_times'] < 1
      return enDays || enUser || enTimes
    },
    // 判断是否为租户后台
    checkTenant(isTenant, module) {
      if (!isTenant) return true
      else {
        const tenantId = sessionStorage.getItem('currentTenantId') && sessionStorage.getItem('currentTenantId') != -1
        if (tenantId) {
          if (isTenant == 1) return true
          if (isTenant == 3 && module.tax_no != 'k3') return true
        } else {
          if (isTenant == 2) return true
          else return false
        }
      }
    },
    showFuns(funs, module) {
      this.drawerSize = '70%'
      this[funs](module)
    },
    // 银企直联cbs 初始化
    showInitConfigCbs() {
      this.title = '初始化配置'
      this.InitConfigCbs = {}
      const init = this.moduleList.find((i) => i.account_module == 9)
      this.InitConfigCbs = {
        finance_acct_name: init.finance_acct_name,
        finance_client_id: init.finance_client_id,
        finance_client_secret: init.finance_client_secret,
        finance_acct_number: init.finance_acct_number,
        finance_icrmid: init.finance_icrmid,
        finance_pid: init.finance_pid,
        tax_no: init.tax_no,
        totalUseDays: init.totalUseDays,
        initial_open_time: init.initial_open_time,
        url: init.url,
        accountModule: 9
      }
      this.finance_acct_nameList = utils.getAllEnumerateAttr({
        isShowList: true,
        typeKey: 'CbsDockingType',
        allData: this.allEnumerate
      })
      this.showInitsTypeCbs = true
    },
    // 初始化配置
    showInitConfig() {
      this.title = '初始化配置'
      this.InitConfig = {}
      const init = this.moduleList.find((i) => i.account_module == 6)
      this.InitConfig = {
        finance_acct_name: init.finance_acct_name,
        finance_acct_number: init.finance_acct_number,
        finance_client_id: init.finance_client_id,
        finance_client_secret: init.finance_client_secret,
        finance_icrmid: init.finance_icrmid,
        finance_orgname: init.finance_orgname,
        finance_pid: init.finance_pid,
        finance_user_name: init.finance_user_name,
        finance_user_password: init.finance_user_password,
        tax_no: init.tax_no,
        tax_no_name: '金蝶云旗舰版',
        totalUseDays: init.totalUseDays,
        initial_open_time: init.initial_open_time,
        accountModule: 6
      }
      this.showInitsType = true
    },
    // 展开企业列表选择器
    ShowFinaceOraname() {
      if (
        this.InitConfig.finance_user_name == '' ||
        this.InitConfig.finance_user_name == null ||
        this.InitConfig.finance_user_password == '' ||
        this.InitConfig.finance_user_password == null
      ) {
        this.$message.error('请输入用户名或者密码')
        return false
      }
      this.title = '企业选择器'
      this.$http
        .get(
          '${third}/kis/ultimate/getProdInstDataVoListAll?finance_user_name=' +
            `${this.InitConfig.finance_user_name}&finance_user_password=` +
            `${this.InitConfig.finance_user_password}`
        )
        .then((res) => {
          this.tableData = res && res.data.length > 0 ? res.data : []
        })
      this.showFinceName = true
    },
    // 选择企业
    handleSelectionChange(data) {
      if (data && data.length > 1) {
        return this.$message.error('请选择一个企业')
      }
      this.FinanceDate = data[0]
    },
    // 企业回写
    saveFinance() {
      this.showFinceName = false
      this.InitConfig.finance_pid = this.FinanceDate.pid
      this.InitConfig.finance_orgname = this.FinanceDate.orgname
    },
    ShowAcctChangeName() {
      if (this.InitConfig.finance_pid == '' || !this.InitConfig.finance_pid || this.InitConfig.finance_pid == null) {
        this.$message.error('请选择企业')
        return false
      }
      this.title = '账套选择器'
      this.$http
        .get(
          '${third}/kis/ultimate/getAccountAppListAll?finance_user_name=' +
            `${this.InitConfig.finance_user_name}&finance_user_password=` +
            `${this.InitConfig.finance_user_password}&pid=` +
            `${this.InitConfig.finance_pid}`
        )
        .then((res) => {
          this.AcctTable = res && res.data.length > 0 ? res.data : []
        })
      this.showAcctName = true
    },
    handleAcctChange(data) {
      if (data && data.length > 1) {
        return this.$message.error('请选择一个账套')
      }
      this.AcctDate = data[0]
    },
    saveAcct() {
      this.showAcctName = false
      this.InitConfig.finance_acct_number = this.AcctDate.acctnumber
      this.InitConfig.finance_acct_name = this.AcctDate.acctname
      this.InitConfig.finance_icrmid = this.AcctDate.icrmid
    },
    saveSubTypeCbs() {
      this.loading = true
      let url = window.context.third + '/system/account_mangement/openOrCancelModule?tenantId=' + this.tenantId
      req.post(url, this.InitConfigCbs).then(() => {
        this.loading = false
        this.showInitsTypeCbs = false
        this.$message.success('操作成功')
        this.getAccountMangement()
      })
    },
    saveSubType() {
      this.loading = true
      let url = window.context.third + '/system/account_mangement/openOrCancelModule?tenantId=' + this.tenantId
      req.post(url, this.InitConfig).then(() => {
        this.loading = false
        this.showInitsType = false
        this.$message.success('操作成功')
        this.getAccountMangement()
      })
    },
    // 关闭提醒对话框
    closeRemider() {
      this.showRemindQCC = false
      this.showRemindOther = false
    },
    // 关闭维护对话框
    closeMaintain(val) {
      this.showMaintainDialog = false
      if (val) this.getAccountMangement()
    },
    closeRelateUser() {
      this.showRelateUser = false
    },
    // 展示维护对话框
    showMaintain(item) {
      this.reminderData = item
      this.showMaintainDialog = true
    },
    // 展示提醒对话框
    showReminder(item) {
      this.reminderData = item
      if (item.account_module == 3 || item.account_module == 4 || item.account_module == 10 || item.account_module == 8) {
        this.showRemindQCC = true
      } else {
        this.showRemindOther = true
      }
    },
    showXzSyncUser() {
      this.$refs.eipUserDialog.showDialog()
    },
    showXzConfigDialog(item) {
      this.xzConfig.accountModule = item.account_module
      this.xzConfig.openStatus = item.open_status
      this.xzConfig.company_name = item.company_name
      this.xzConfig.credit_code = item.credit_code
      this.xzConfig.contact_name = item.contact_name
      this.xzConfig.contact_phone = item.contact_phone
      this.showXzConfig = true
    },
    xzConfigConfirm() {
      this.$refs['xzConfigForm'].validate((valid) => {
        if (valid) {
          this.loading = true
          let url = window.context.third + '/system/account_mangement/openOrCancelModule?tenantId=' + this.tenantId
          req
            .post(url, this.xzConfig)
            .then(() => {
              this.showXzConfig = false
              this.$message.success('操作成功')
              this.getAccountMangement()
            })
            .finally(() => {
              this.loading = false
            })
        }
      })
    },
    sendSmsCode() {
      portal.sendCodeByMobile(this.tenantId, this.xzConfig.contact_phone).then((res) => {
        if (res.state) {
          let that = this
          this.$message.success('验证码发送成功')
          let interval = setInterval(function () {
            --that.reSendName
            if (that.reSendName < 0) {
              that.reSendName = 60
              clearInterval(interval)
            }
          }, 1000)
        }
      })
    },
    // 新筑时代用户信息同步
    xzSyncUserDialogConfirm(resp) {
      portal.xzSyncUser(resp).then((resp) => {
        if (resp.state) {
          this.$message.success('同步成功')
        } else {
          this.$message.success('同步失败')
        }
      })
    },
    // 新筑时代基础信息同步
    xzSyncJob() {
      portal.xzSyncJob().then((resp) => {
        if (resp.state) {
          this.$message.success('同步成功')
        } else {
          this.$message.success('同步失败')
        }
      })
    },
    // 新筑时代基础信息同步
    xzSyncPos() {
      portal.xzSyncPos().then((resp) => {
        if (resp.state) {
          this.$message.success('同步成功')
        } else {
          this.$message.success('同步失败')
        }
      })
    },
    // 新筑时代基础信息同步
    xzSyncOrg() {
      portal.xzSyncOrg().then((resp) => {
        if (resp.state) {
          this.$message.success('同步成功')
        } else {
          this.$message.success('同步失败')
        }
      })
    },
    // 开通状态转换
    openStatusTrans(data) {
      return data ? '已开通' : '未开通'
    },
    typeListTrans(data) {
      let temp = this.typeList.find((item) => item.code == data)
      return temp ? temp.name : ''
    },
    beforeCloseXzSyncUserDialog() {
      this.showXzConfig = false
    },
    beforeCloseDialog1() {
      this.showTaxNo = false
    },
    beforeCloseDialog6() {
      this.showBWTaxNo = false
    },
    beforeCloseDialog2() {
      this.showNcType = false
    },
    beforeCloseZfbDialog() {
      this.showZfb = false
    },
    beforeCloseCbsDialog() {
      this.showCbsType = false
    },
    beforeCloseMtDialog() {
      this.showMtType = false
    },
    beforeCloseInitDialog() {
      this.showInitsType = false
      this.showInitsTypeCbs = false
    },
    beforeCloseFinceDialog() {
      this.showFinceName = false
    },
    beforeCloseAcctDialog() {
      this.showAcctName = false
    },
    beforeCloseDialog() {
      this.showDetail = false
    },
    handleClose() {
      this.drawer = false
    },
    getAccountMangement() {
      req.get('${third}/system/account_mangement/getById?tenantId=' + this.tenantId).then((res) => {
        let response = res.data
        if (response && response.length > 0) {
          // moduleList过滤
          // this.moduleList = response;
          this.moduleList = response.filter((x) => this.typeList.find((itemsMenu) => x.account_module == itemsMenu.code))
          handleType(this.moduleList.find((i) => i.account_module == 6).tax_no)
          this.handleOnlineUser(this.moduleList.find((i) => i.account_module == 1))
        }
      })
    },
    // 申请开通
    applyOpen() {
      const { currentUser } = this.$store.state.login
      const param = {
        userId: currentUser.userId,
        corpId: sessionStorage.getItem('tenantId'),
        corpName: sessionStorage.getItem('tenantName')
      }
      flow.getApplyOpen(param).then(
        (response) => {
          if (response.state) {
            window.open(response.value)
          }
        },
        (error) => {}
      )
    },
    // 注册跳外链
    registerOpen() {},
    // 获取登录地址
    loginAddress() {
      const { currentUser } = this.$store.state.login
      const param = {
        userId: currentUser.userId,
        corpId: sessionStorage.getItem('tenantId'),
        corpName: sessionStorage.getItem('tenantName')
      }
      flow.getLoginAddressn(param).then(
        (response) => {
          if (response.state) {
            window.open(response.value)
          }
        },
        (error) => {}
      )
    },
    // 同步信息
    synchronization() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        fontSize: '24',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      flow.getMeituanTripSyncAll({}).then(
        (response) => {
          if (response.state) {
            loading.close()
            this.$message.success(response.message)
          }
        },
        (error) => {}
      )
    },
    showNcConfig(module) {
      this.title = '凭证配置'
      this.$http.get('${third}/third_financial_mapping/getEnumDockingTypeMap').then((res) => {
        if (res && res.data) {
          this.optionsList = res.data
        }
      })
      this.ncConfig.ncType = module.tax_no
      this.ncConfig.ncUrl = module.url
      this.ncConfig.ncFinanceClientId = module.finance_client_id
      this.ncConfig.ncFinanceClientSecret = module.finance_client_secret
      this.showNcType = true
    },
    showtaxNo(module) {
      this.title = '税号'
      this.tax.taxNo = module.tax_no
      this.showTaxNo = true
    },
    showBwTaxNo(module) {
      this.title = '百望进项发票税号'
      this.tax.taxNo = module.tax_no
      this.showBWTaxNo = true
    },
    showRecharge(account_module) {
      this.recharge = {
        accountModule: account_module,
        title: '',
        startTime: '',
        endTime: '',
        amount: '',
        remarks: '',
        currentUser: this.$store.state.user.currentUserDetail.user.fullname,
        createTime: new Date()
      }
      if (account_module === 1) {
        this.recharge.title = '软件基础模块充值'
      } else if (account_module === 2) {
        this.recharge.title = 'BI模块充值'
      } else if (account_module === 3) {
        this.recharge.title = '企查查基础数据模块充值'
      } else if (account_module === 4) {
        this.recharge.title = '企查查风险监控模块充值'
      } else if (account_module === 5) {
        this.recharge.title = '税务发票模块充值'
      } else if (account_module === 6) {
        this.recharge.title = '凭证推送'
      } else if (account_module === 8) {
        this.recharge.title = 'OCR'
      }
      this.showDetail = true
    },
    showZfbConfig(module) {
      this.title = '绑定账号'
      this.zfb.zfbAccount = module.alipay_account
      this.zfb.zfbName = module.alipay_name
      this.zfb.zfbRemarkes = module.remark
      this.showZfb = true
    },
    showCbsConfig(module) {
      this.title = 'CBS配置'
      this.cbsConfig.cbsOrgNo = module.tax_no
      this.cbsConfig.cbsUrl = module.url
      this.cbsConfig.finance_acct_name = module.finance_acct_name
      this.finance_acct_nameList = utils.getAllEnumerateAttr({
        isShowList: true,
        typeKey: 'CbsDockingType',
        allData: this.allEnumerate
      })
      this.showCbsType = true
    },
    mtSetConfig(module) {
      this.title = '美团配置参数'
      this.mtConfig.entId = module.entId
      this.mtConfig.accessKey = module.accessKey
      this.mtConfig.secretKey = module.secretKey
      this.showMtType = true
    },
    saveTaxNo() {
      this.loading = true
      let url = window.context.third + '/system/account_mangement/openOrCancelModule?tenantId=' + this.tenantId
      let param = {
        accountModule: 5,
        openStatus: '',
        taxNo: this.tax.taxNo
      }
      req.post(url, param).then((res) => {
        this.loading = false
        this.showTaxNo = false
        this.getAccountMangement()
      })
    },
    saveBWTaxNo() {
      this.loading = true
      let url = window.context.third + '/system/account_mangement/openOrCancelModule?tenantId=' + this.tenantId
      let param = {
        accountModule: 14,
        openStatus: '',
        taxNo: this.tax.taxNo
      }
      req.post(url, param).then((res) => {
        this.loading = false
        this.showBWTaxNo = false
        this.getAccountMangement()
      })
    },
    saveNc() {
      this.loading = true
      let url = window.context.third + '/system/account_mangement/openOrCancelModule?tenantId=' + this.tenantId
      let param = {
        accountModule: 6,
        openStatus: '',
        taxNo: this.ncConfig.ncType,
        url: this.ncConfig.ncUrl,
        finance_client_secret: this.ncConfig.ncFinanceClientSecret,
        finance_client_id: this.ncConfig.ncFinanceClientId
      }
      req.post(url, param).then((res) => {
        this.loading = false
        this.showNcType = false
        this.getAccountMangement()
      })
    },
    saveRecharge() {
      this.loading = true
      if (this.recharge.amount == '') {
        this.$message.info('充值金额不能为空！')
      } else {
        if (this.recharge.startTime == '') {
          this.$message.info('开始日期不能为空！')
        } else {
          if (this.recharge.endTime == '') {
            this.$message.info('结束日期不能为空！')
          } else {
            if (this.recharge.startTime && this.recharge.endTime) {
              let start = new Date(Date.parse(this.recharge.startTime))
              let end = new Date(Date.parse(this.recharge.endTime))
              if (start > end) {
                this.$message.info('结束日期不能早于开始日期！')
              } else {
                let url = window.context.third + '/system/recharge_record/'
                let param = {
                  account_module: this.recharge.accountModule,
                  end_time: this.recharge.endTime,
                  id: '',
                  recharge_money: this.recharge.amount,
                  remark: this.recharge.remarks,
                  start_time: this.recharge.startTime,
                  tenant_id_: this.tenantId
                }
                req.post(url, param).then((res) => {
                  this.loading = false
                  this.showDetail = false
                  this.getAccountMangement()
                })
              }
            }
          }
        }
      }
    },
    saveDataZfbSign() {
      this.loading = true
      if (!this.zfb.zfbAccount) {
        this.$message.info('支付宝帐号不能为空！')
      } else {
        if (!this.zfb.zfbName) {
          this.$message.info('支付宝名称不能为空！')
        } else {
          let url = window.context.third + '/system/account_mangement/openOrCancelModule?tenantId=' + this.tenantId
          let param = {
            accountModule: 7, // 支付宝
            openStatus: '',
            alipayAccount: this.zfb.zfbAccount,
            alipayName: this.zfb.zfbName,
            remark: this.zfb.zfbRemarkes
          }
          req.post(url, param).then((res) => {
            this.loading = false
            this.showZfb = false
            if (res.data) {
              this.getAccountMangement()
              req.get('${third}/aliPay/openInviteOrderCreate').then((resf) => {
                if (resf.data.success) {
                  window.open(resf.data.body)
                } else {
                  this.$message.error(resf.data.subMsg)
                }
              })
            }
          })
        }
      }
    },
    saveDataZfbOauth() {
      this.loading = true
      if (!this.zfb.zfbAccount) {
        this.$message.info('支付宝帐号不能为空！')
      } else {
        if (!this.zfb.zfbName) {
          this.$message.info('支付宝名称不能为空！')
        } else {
          let url = window.context.third + '/system/account_mangement/openOrCancelModule?tenantId=' + this.tenantId
          let param = {
            accountModule: 7, // 支付宝
            openStatus: '',
            alipayAccount: this.zfb.zfbAccount,
            alipayName: this.zfb.zfbName,
            remark: this.zfb.zfbRemarkes
          }
          req.post(url, param).then((res) => {
            this.loading = false
            this.showZfb = false
            if (res.data) {
              this.getAccountMangement()
              req.get(window.context.third + '/aliPay/toOauth', 'json').then((response) => {
                window.open(response.data.message)
              })
            }
          })
        }
      }
    },
    saveCbs() {
      this.loading = true
      let url = window.context.third + '/system/account_mangement/openOrCancelModule?tenantId=' + this.tenantId
      let param = {
        accountModule: 9,
        openStatus: '',
        taxNo: this.cbsConfig.cbsOrgNo,
        finance_acct_name: this.cbsConfig.finance_acct_name,
        url: this.cbsConfig.cbsUrl
      }
      req.post(url, param).then((res) => {
        this.loading = false
        this.showCbsType = false
        this.getAccountMangement()
      })
    },
    saveMt() {
      this.loading = true
      let url = window.context.third + '/system/account_mangement/openOrCancelModule?tenantId=' + this.tenantId
      let param = {
        accountModule: 11,
        entId: this.mtConfig.entId,
        accessKey: this.mtConfig.accessKey,
        secretKey: this.mtConfig.secretKey
      }
      req.post(url, param).then((res) => {
        this.loading = false
        this.showMtType = false
        this.getAccountMangement()
      })
    },
    mtSyncInfo() {
      this.loading = true
      let url = window.context.third + '/meiTuan/trip/syncAll'
      req.post(url, {}).then((res) => {
        if (res.state) {
          this.$message.success(res.message)
        }
        // this.getAccountMangement();
      })
    },
    showRecord(account_module) {
      this.isHaving = false
      this.openStatus = ''
      if (account_module == 1) {
        this.title = '软件基础模块充值'
        this.account_module = 1
        this.openStatus = true
      } else if (account_module == 2) {
        this.title = 'BI模块充值'
        this.account_module = 2
        this.openStatus = this.bi_val
      } else if (account_module == 3) {
        this.title = '企查查基础数据模块充值'
        this.account_module = 3
        this.openStatus = this.base_val
      } else if (account_module == 4) {
        this.title = '企查查风险监控模块充值'
        this.account_module = 4
        this.openStatus = this.risk_val
      } else if (account_module == 5) {
        this.title = '税务发票模块充值'
        this.account_module = 5
        this.openStatus = this.ray_val
      } else if (account_module == 6) {
        this.title = '凭证推送模块充值'
        this.account_module = 6
        this.openStatus = this.nc_val
      } else if (account_module == 7) {
        this.title = '支付宝绑定账号更换记录'
        this.account_module = 7
        this.openStatus = this.nc_val
      }
      let url = window.context.third + '/system/recharge_record/getRecordsByTenantIdAndModule'
      let param = {
        accountModule: account_module,
        openStatus: '',
        taxNo: ''
      }
      req.post(url, param).then((res) => {
        this.chargeData = []
        let response = res.data
        if (response.length > 0) {
          this.isHaving = true
          response.forEach((item) => {
            let list = {
              createTime: item.createTime,
              createByName: item.createByName,
              start_time: item.start_time,
              end_time: item.end_time,
              recharge_money: item.recharge_money,
              remark: item.remark
            }
            this.chargeData.push(list)
          })
        } else {
          this.isHaving = false
        }
      })
      this.drawer = true
    },
    changeState(module) {
      let url = window.context.third + '/system/account_mangement/openOrCancelModule?tenantId=' + this.tenantId
      let param = {
        accountModule: module.account_module,
        openStatus: module.open_status,
        taxNo: ''
      }
      if (module.accountModule == '11') {
        param.systemType = 'meituan'
      }
      req.post(url, param).then((res) => {
        let response = res.data
        if (response == true && module.open_status === 1) {
          this.$message.info('开启成功！')
          this.getAccountMangement()
        }
        if (response == true && module.open_status === 0) {
          this.$message.info('关闭成功！')
          this.getAccountMangement()
        }
      })
    },
    // 充值组件拉取
    immediateIn(item) {
      this.reminderData = item
      this.showInsertOrder = true
    },
    // 充值组件拉取
    closeInsert() {
      this.showInsertOrder = false
    },
    // 账单记录
    billRecord(item) {
      this.reminderData = item
      this.showbillRecord = true
    },
    // 关联用户
    relateUser(item) {
      this.reminderData = item
      this.showRelateUser = true
    },
    // 关闭账单记录
    closeBillingRecord() {
      this.showbillRecord = false
    },
    // 打开dd参数配置
    showDDMaintain(data) {
      if (data.account_config) {
        Object.keys(this.ddValue).forEach((key) => {
          this.ddValue[key] = data.account_config[key]
        })
        this.ddValue.id = data.account_config.id
        this.corpIDChange()
      } else {
        // 获取劳务班组
        this.ddValue.refId = data.id
      }
      this.title = '钉钉考勤接口参数配置'
      this.showDDConfig = true
    },
    tianyanchaPz(data) {
      if (data.tax_no) {
        this.tycValue.tax_no = data.tax_no
        this.tycValue.id = data.id
      }
      this.title = '天眼查参数配置'
      this.showTYCConfig = true
    },
    // 打开美团参数配置
    cspz(data) {
      if (data.account_config) {
        Object.keys(this.ddValue).forEach((key) => {
          this.ddValue[key] = data.account_config[key]
        })
        this.ddValue.id = data.account_config.id
        this.corpIDChange()
      } else {
        // 获取劳务班组
        this.ddValue.refId = data.id
      }
      this.title = '美团参数配置'
      this.showMTConfig = true
    },
    // 打开美团参数配置
    showQSRConfig(data) {
      if (data.account_config) {
        Object.keys(this.ddValue).forEach((key) => {
          this.ddValue[key] = data.account_config[key]
        })
        this.ddValue.id = data.account_config.id
      } else {
        this.ddValue.refId = data.id
      }
      this.title = '默认签署人配置'
      this.showQSRConfigVisible = true
    },

    // 打开用车规则列表
    ycgzwh(data) {
      console.log(data, '用车维护')
      this.reminderData = data
      this.ycgzList = true
    },
    // 关闭用车规则列表
    closeYcgzList() {
      this.ycgzList = false
    },

    corpIDChange() {
      if (this.ddValue.corp_id && this.ddValue.app_key && this.ddValue.app_secret) {
        let params = {
          account_config: {
            corp_id: this.ddValue.corp_id,
            app_key: this.ddValue.app_key,
            app_secret: this.ddValue.app_secret
          },
          open_status: 1
        }
        let url = window.context.third + '/account/account_config/getLaborTeamDept'
        req.post(url, params).then((res) => {
          if (res) {
            this.ddConfigLwClass = res.data
          }
        })
      }
    },
    // 关闭账单记录
    beforeCloseDialogDD() {
      this.showDDConfig = false
    },
    // 关闭美团配置弹窗
    beforeCloseDialogMT() {
      this.showMTConfig = false
    },
    beforeCloseDialogQSR() {
      this.showQSRConfigVisible = false
    },

    // 关闭账单记录
    saveDDMaintain() {
      let params = {
        ...this.ddValue
      }
      if (!params.corp_id) {
        return this.$message.error('请输入CorpID')
      }
      if (!params.app_key) {
        return this.$message.error('请输入AppKey')
      }
      if (!params.app_secret) {
        return this.$message.error('请输入app_secret')
      }
      if (!params.ticket) {
        return this.$message.error('请输入ticket')
      }
      if (!params.labor_team_dept_id) {
        return this.$message.error('请输入劳务班组架构')
      }
      if (!params.fixed_date) {
        return this.$message.error('请输入考勤月报固化时间')
      }
      if (!params.worker_overage) {
        return this.$message.error('请输入工人进场超龄需要上传体检报告')
      }
      this.loading = true
      let url = window.context.third + '/account/account_config/'
      req
        .post(url, params)
        .then((res) => {
          this.loading = false
          if (res) {
            this.$message.info('操作成功！')
            this.beforeCloseDialogDD()
            this.getAccountMangement()
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    saveTYCMaintain() {
      this.$refs['tycConfigForm'].validate((valid) => {
        if (valid) {
          this.loading = true
          let url = window.context.third + '/system/account_mangement/openOrCancelModule?tenantId=' + this.tenantId
          let param = {
            accountModule: 15,
            openStatus: '',
            taxNo: this.tycValue.tax_no
          }
          req
            .post(url, param)
            .then((res) => {
              this.loading = false
              if (res) {
                this.$message.info('操作成功！')
                this.beforeCloseDialogTYC()
                this.getAccountMangement()
              }
            })
            .catch(() => {
              this.loading = false
            })
        }
      })
    },
    //美团配置弹框确定
    saveMTMaintain() {
      let params = {
        ...this.ddValue
      }
      this.$refs['mtConfigForm'].validate((valid) => {
        if (valid) {
          this.loading = true
          let url = window.context.third + '/account/account_config/'
          req
            .post(url, params)
            .then((res) => {
              this.loading = false
              if (res) {
                this.$message.info('操作成功！')
                this.beforeCloseDialogMT()
                this.getAccountMangement()
              }
            })
            .catch(() => {
              this.loading = false
            })
        }
      })
    },
    //美团配置弹框确定
    saveQSRMaintain() {
      let params = {
        ...this.ddValue
      }
      this.$refs['QSRConfigForm'].validate((valid) => {
        if (valid) {
          this.loading = true
          let url = window.context.third + '/account/account_config/'
          req
            .post(url, params)
            .then((res) => {
              this.loading = false
              if (res) {
                this.$message.info('操作成功！')
                this.beforeCloseDialogQSR()
                this.getAccountMangement()
              }
            })
            .catch(() => {
              this.loading = false
            })
        }
      })
    },
    async getOnlineUser() {
      let resp = await uc.getOnlineUserCount(this.tenantId)
      this.onlineUserCount = resp.value
    },
    handleOnlineUser(module) {
      module.online_user = this.onlineUserCount
    },
    handleButtonEvent(key) {
      // console.info(key)
      switch (key) {
        case 'online_user':
          this.showOnlineUserDialog = true
          break
        default:
          break
      }
    },
    closeOnlineUserRecord() {
      this.showOnlineUserDialog = false
    }
  }
}
</script>

<style lang="scss" scoped>
#border {
  padding: 10px;
  height: 100%;
  margin-left: -20px;
  margin-right: -20px;
  background: #f2f3f5;
  overflow-y: auto;
}
.leftImage {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  float: left;
  margin-right: 10px;
}
.payDetail {
  border: 1px solid #e4e7ed;
  height: 6rem;
  padding: 10px;
}

.box-body {
  display: flex;
  flex-wrap: wrap;
}

.pay_title {
  font-size: 14px;
  font-weight: 600;
  color: #333333;
  line-height: 24px;
}

.bottom_row {
  text-align: left;
  display: flex;
  align-items: center;
  margin-top: 10px;
}

.pay_content {
  font-size: 14px;
  font-weight: 400;
  color: #8c8c90;
  line-height: 20px;
}

.text {
  font-size: 14px;
}

.item {
  margin-bottom: 18px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: '';
}

.clearfix:after {
  clear: both;
}

.box-card {
  width: calc((100% - 80px) / 4);
  margin: 10px 20px 10px 0;
  background-color: #fff;
  border-radius: 4px;
  border: 0;
}

.bottom {
  text-align: center;
}

.drawer_content {
  padding: 0 20px;
}

.noData_tips {
  height: 100%;
  width: 100%;
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
}
.pay_status {
  font-size: 12px;
  padding: 0 5px;
  border-radius: 2px;
}
.pay_status_yes {
  color: rgba(38, 122, 0, 100);
  border: 1px solid rgba(38, 122, 0, 100);
}
.pay_status_no {
  color: rgba(208, 208, 208, 100);
  border: 1px solid rgba(208, 208, 208, 100);
}
.textItem {
  height: 195px;
  padding: 0 10px;
}
.redColor {
  color: red;
  border: 1px solid red;
  padding: 3px;
  display: inline-flex;
}
.redAction {
  height: 60px;
  color: red;
  div {
    margin: 5px 0;
    color: red;
    text-align: left;
  }
}
.primaryBtn {
  background-color: #155bd4;
  padding: 6px 10px;
  color: #fff;
}
.blurBorderBtn {
  border: 1px solid #155bd4;
  color: #155bd4;
  padding: 6px 10px;
}
@media screen and (max-width: 1475px) {
  .primaryBtn,
  .blurBorderBtn {
    /deep/span {
      font-size: 12px !important;
    }
  }
}
.customDivider {
  margin: 10px 0;
}
.typeTIle {
  font-size: 16px;
  font-weight: 600;
  color: #333333;
  line-height: 22px;
  height: 22px;
  padding-left: 10px;
  border-left: 3px solid #155bd4;
  margin: 0;
}
::v-deep .el-card__header {
  padding: 10px;
  position: relative;
}
.bttonlist {
  margin: 5px 5px 15px 5px;
  display: flex;
  align-items: center;
  //justify-content: center;
  flex-wrap: wrap;
}
.tagStatus {
  position: absolute;
  right: 0;
  border-radius: 11px 0px 0px 11px;
  top: 10px;
  font-size: 12px;
  font-weight: 400;
  color: #ffffff;
  line-height: 22px;
  height: 22px;
  padding: 0 10px;
}
.tagStatusO {
  background: #e78319;
}
.tagStatusR {
  background: #ff453a;
}
.tagStatusG {
  background: #23af46;
}
</style>
